import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useImperativeHandle, useMemo, useRef, useState } from "react";
import InputPanel from "../../others/input-panel/index.js";
import useIsMobile from "../../../../hooks/device/useIsMobile.js";
import useInput from "../../../../hooks/forms/useInput/index.js";
import Autocomplete from "../autocomplete/index.js";
export const AutocompleteModal = /*#__PURE__*/ forwardRef((props, ref)=>{
    const refInputMobile = useRef(null);
    useImperativeHandle(ref, ()=>refInputMobile.current);
    const { disabled =false , label , literals , hasError =false , onChange  } = props ?? {};
    const { modalTitle =''  } = literals ?? {};
    const [value, setValue] = useState(props.value);
    const isMobile = useIsMobile();
    const onChangeAutocomplete = useCallback((close)=>(suggestion)=>{
            setValue(suggestion);
            close();
            if (onChange) onChange(suggestion);
        }, [
        onChange
    ]);
    const renderPanelContent = useCallback(({ close  })=>/*#__PURE__*/ _jsx(Autocomplete, {
            ...props,
            onChange: onChangeAutocomplete(close),
            forceGetDataOnRender: isMobile
        }), [
        isMobile,
        onChangeAutocomplete,
        props
    ]);
    const inputProps = useMemo(()=>({
            label,
            value: value?.text ?? '',
            hasError,
            disabled
        }), [
        disabled,
        hasError,
        label,
        value?.text
    ]);
    const panel = useMemo(()=>({
            header: modalTitle,
            content: renderPanelContent
        }), [
        modalTitle,
        renderPanelContent
    ]);
    const modalProps = useMemo(()=>({
            color: 'primary'
        }), []);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "AutocompleteModal",
        children: /*#__PURE__*/ _jsx(InputPanel, {
            ref: ref,
            inputProps: inputProps,
            panel: panel,
            modalProps: modalProps
        })
    });
});
AutocompleteModal.displayName = 'AutocompleteModal';
export const FormAutocompleteModal = (props)=>{
    const { isHiddenRequired: _isHiddenRequired , ...rest } = props;
    const { field , error , hasError , label  } = useInput(props);
    return /*#__PURE__*/ _jsx(AutocompleteModal, {
        ...rest,
        ...field,
        error: error,
        hasError: hasError,
        label: label
    });
};
export default AutocompleteModal;

//# sourceMappingURL=index.js.map